import { ThunkMiddleware } from 'redux-thunk';
import { AnyAction } from 'redux';

import asyncRetry from 'ha/utils/asyncRetry';
import { TwilioClient } from 'ha/types/Twilio';
import { GlobalState } from 'ha/types/store';
import { AppServices } from 'ha/services/getAppServices';

import { initRealtimeService } from '../actions';
import { connectionSubscription, channelSubscription } from '../utils';
import { dontRetryHttps } from '../constants';
import { NetworkError } from '../types';

interface Props {
  debug: boolean;
  onError: (e: Error) => void;
  getChannelId: (x: GlobalState) => string;
}

const shouldRetry = (error: NetworkError) =>
  !dontRetryHttps.includes(error.status);

export default ({
  debug,
  onError,
  getChannelId,
}: Props): ThunkMiddleware<GlobalState, AnyAction, AppServices> => {
  let initialized = false;

  return ({ dispatch, getState }) => next => action => {
    next(action);

    const channelId = getChannelId(getState());

    if (channelId && !initialized) {
      initialized = true;

      const initDispatch = () => dispatch(initRealtimeService(debug));

      asyncRetry<TwilioClient, NetworkError>(initDispatch, { shouldRetry })
        .then((client: TwilioClient) =>
          connectionSubscription(dispatch, client),
        )
        .then((client: TwilioClient) =>
          channelSubscription(dispatch, client, channelId),
        )
        .catch(error => {
          if (
            error &&
            ((error.status && !dontRetryHttps.includes(error.status)) ||
              !error.status)
          ) {
            onError(error);
          }
        });
    }
  };
};
